import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";
import Combobox from "@github/combobox-nav";

export default class extends Controller {
  static values = {
    searchPath: String,
  };
  static targets = ["field", "input", "frame", "list", "submit"];

  connect() {
    this.search = debounce(this.search, 200);

    // Triggers when user presses enter on a bird
    this.listTarget.addEventListener("combobox-commit", (event) => {
      const value = event.target.dataset.comboboxValueParam;
      const text = event.target.dataset.comboboxTextParam;
      this.select(value, text);
    });

    this.frameTarget.addEventListener("turbo:frame-render", () => {
      if (document.activeElement === this.inputTarget) {
        this.open();
      }
    });

    this.search();

    this.combobox?.destroy();

    this.combobox = new Combobox(this.inputTarget, this.listTarget);

    this.isOpen = false;
  }

  input() {
    this.search();
  }

  activate(event) {
    this.frameTarget.querySelectorAll("li").forEach((li) => {
      li.setAttribute("aria-selected", false);
    });

    event.currentTarget.setAttribute("aria-selected", true);
  }

  focus() {
    if (!this.isOpen) {
      this.display();
    }
  }

  search() {
    const src = `${this.searchPathValue}?q=${
      this.inputTarget.value
    }&turbo_frame=${this.frameTarget.getAttribute("id")}`;
    this.frameTarget.setAttribute("src", src);
  }

  display() {
    if (this.empty || this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  itemClick(event) {
    const { text, value } = event.params;
    this.select(value, text);
  }

  select(value, text) {
    this.inputTarget.value = text;
    this.fieldTarget.value = value;
    this.dispatch("select", { detail: { text, value } });
    this.close();
  }

  close() {
    this.isOpen = false;
    this.listTarget.classList.add("hidden");
    this.combobox?.stop();
  }

  open() {
    this.inputTarget.focus();
    this.listTarget.classList.remove("hidden");
    this.isOpen = true;
    this.combobox.start();
  }

  get empty() {
    return this.listTarget.querySelector("li") === null;
  }
}
